import { __awaiter } from "tslib";
import React, { useContext } from 'react';
import Routing from './Routing';
import LabSimService, { NoSelectionIndicator, StateContext, } from './services/LabSimService';
import ErrorPage from './pages/ErrorPage';
import LoadingPage from './pages/LoadingPage';
import { parse } from 'query-string';
import PlatformHelper, { IntegrationType } from './helpers/PlatformHelper';
import './App.less';
import '@testout/labsim-ui-atomics/dist/index.css';
export default class App extends React.Component {
    constructor(props) {
        super(props);
        this.resolveState = () => {
            let stateId = this.parseStateFromQuery();
            try {
                if (stateId) {
                    localStorage === null || localStorage === void 0 ? void 0 : localStorage.setItem('state', stateId);
                }
                else {
                    stateId = localStorage === null || localStorage === void 0 ? void 0 : localStorage.getItem('state');
                }
            }
            catch (error) {
                this.setState({ error: 'No access to local storage' });
            }
            return stateId;
        };
        this.parseStateFromQuery = () => {
            let localState = '';
            if (window.location.search !== null) {
                const queryParams = parse(window.location.search);
                localState = queryParams.state;
            }
            return localState;
        };
        this.MaxRetries = 3;
        this.getMigratedToLockedProducts = () => {
            var _a;
            if (((_a = this.state.lockedVersions) === null || _a === void 0 ? void 0 : _a.length) === 0)
                return [];
            if (this.state.products == null)
                return [];
            const migratedLockedProductVersions = this.state
                .products.isbns.filter((p) => {
                var _a;
                return (_a = this.state.lockedVersions) === null || _a === void 0 ? void 0 : _a.map((l) => l.isbn).some((l) => l === p.isbn);
            })
                .map((v) => v.versions.map((v) => v.migratedToProductVersionId))
                .reduce((acc, val) => acc.concat(val), [])
                .filter((v, i, a) => a.indexOf(v) === i)
                .filter((p) => p != null);
            const migratedLockedProducts = this.state.products.isbns.filter((p) => {
                return p.versions.find((v) => migratedLockedProductVersions === null || migratedLockedProductVersions === void 0 ? void 0 : migratedLockedProductVersions.some((m) => m === v.productVersionId));
            });
            return migratedLockedProducts;
        };
        this.getMigratedFromLockedProducts = () => {
            var _a;
            if (((_a = this.state.lockedVersions) === null || _a === void 0 ? void 0 : _a.length) === 0)
                return [];
            if (this.state.products == null)
                return [];
            const lockedVersionIds = this.state.lockedVersions.map((l) => l.productVersionId);
            const productsMigratedFrom = this.state.products.isbns.filter((p) => {
                return (p.versions.find((v) => {
                    return lockedVersionIds.some((l) => l === v.migratedToProductVersionId);
                }) != null);
            });
            return productsMigratedFrom;
        };
        this.state = {
            assignmentGroups: [],
            canvasDataFailed: false,
            canvasDataLoaded: false,
            customExamsLoaded: false,
            featureFlags: {},
            featureFlagsLoaded: false,
            loadingData: true,
            loadingResourceTxt: '',
            modules: [],
            productsLoaded: false,
            stateId: this.resolveState(),
            useLatestResource: false,
        };
    }
    componentDidMount() {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            if (this.state.stateId == null) {
                this.setState({ error: 'No State Guid Found' });
            }
            else {
                yield this.fetchStateFromServer();
                if (this.state.error != null && this.state.error.length > 0) {
                    return;
                }
                try {
                    this._canvasDataPromise = this.getCanvasData();
                    this._customExamsPromise = this.getCustomExamData();
                    this._productDataPromise = this.getProductData();
                    this._lockedVersionsPromise = this.getLockedVersions();
                    yield this.getFeatureFlags();
                }
                catch (error) {
                    const message = error instanceof Error ? error.message : 'Unknown startup error';
                    this.setState({ error: message });
                }
                const isEduApp = ((_a = this.state.serverState) === null || _a === void 0 ? void 0 : _a.integrationType.toLowerCase()) === IntegrationType.EduApp;
                const isPlugin = ((_b = this.state.serverState) === null || _b === void 0 ? void 0 : _b.integrationType.toLowerCase()) === IntegrationType.Plugin;
                const initialShowRetirementNotice = isEduApp || isPlugin;
                this.setState({ loadingData: false, showRetirementNotice: initialShowRetirementNotice });
            }
        });
    }
    getProductData() {
        return __awaiter(this, void 0, void 0, function* () {
            return LabSimService.getProducts().then((productData) => {
                return new Promise((resolve) => {
                    this.setState({
                        products: productData,
                        productsLoaded: true,
                    }, () => resolve(productData));
                });
            });
        });
    }
    getCustomExamData() {
        return __awaiter(this, void 0, void 0, function* () {
            return LabSimService.getCustomExams().then((customExamData) => {
                return new Promise((resolve) => {
                    this.setState({
                        customExams: customExamData,
                        customExamsLoaded: true,
                    }, () => resolve(customExamData));
                });
            });
        });
    }
    getLockedVersions() {
        return __awaiter(this, void 0, void 0, function* () {
            return LabSimService.getClassLockedVersions().then((lockedVersions) => {
                return new Promise((resolve) => {
                    this.setState({
                        lockedVersions,
                    }, () => resolve(lockedVersions));
                });
            });
        });
    }
    getCanvasData() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.state.serverState && !PlatformHelper.isFamilyCanvas(this.state.serverState)) {
                // nothing to load, set this to true
                return new Promise((resolve) => {
                    this.setState({ canvasDataLoaded: true }, resolve);
                });
            }
            let attempts = 0;
            let groups = null;
            while (attempts < this.MaxRetries) {
                try {
                    groups = yield LabSimService.assignmentGroups();
                    break;
                }
                catch (e) {
                    const message = e instanceof Error ? e.message : e;
                    console.log('failed to fetch assignment group data:', message);
                }
                finally {
                    attempts++;
                }
            }
            if (groups !== null) {
                // if our TO module is not in the list, let's add it here with the placeholder id
                const modules = (groups === null || groups === void 0 ? void 0 : groups.modules) || [];
                if (modules.find((m) => m.name === 'CompTIA Content') == null) {
                    modules.push({ id: NoSelectionIndicator, name: 'CompTIA Content' }); // *** Should this change to CertMaster content/CompTIA content? ***
                }
                return new Promise((resolve) => {
                    this.setState({
                        assignmentGroups: (groups === null || groups === void 0 ? void 0 : groups.assignmentGroups) || [],
                        canvasDataLoaded: true,
                        modules,
                    }, () => {
                        resolve();
                    });
                });
            }
            else {
                // nothing to load, set this to true
                return new Promise((resolve) => {
                    this.setState({ canvasDataFailed: true }, resolve);
                });
            }
        });
    }
    fetchStateFromServer() {
        return __awaiter(this, void 0, void 0, function* () {
            this.setState({ loadingResourceTxt: 'Verifying session' });
            try {
                sessionStorage.getItem('state');
            }
            catch (error) {
                this.setState({
                    error: 'Could not access local storage. Are third party cookies enabled?',
                });
                return;
            }
            try {
                const data = yield LabSimService.getState(this.state.stateId);
                if (!data.isValid) {
                    this.setState({ error: `Could not contact CompTIA servers (${data.error})` });
                    return;
                }
                data.syncOnly = false;
                this.setState({ serverState: data });
                LabSimService.setApiEndpoints(data);
            }
            catch (error) {
                this.setState({ error: `Could not contact CompTIA server (${error})` });
            }
        });
    }
    getFeatureFlags() {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            const userProfileId = (_a = this.state.serverState) === null || _a === void 0 ? void 0 : _a.userProfileId;
            const campusProfileId = (_b = this.state.serverState) === null || _b === void 0 ? void 0 : _b.schoolGuid;
            if (!userProfileId) {
                this.setState({ featureFlags: {}, featureFlagsLoaded: true });
                return;
            }
            try {
                const featureFlags = yield LabSimService.getAllFeatureFlags(userProfileId, campusProfileId);
                this.setState({ featureFlags, featureFlagsLoaded: true });
            }
            catch (error) {
                console.log('failed to load feature flags', error);
                this.setState({ featureFlags: {}, featureFlagsLoaded: true });
            }
        });
    }
    render() {
        if (this.state.error) {
            return React.createElement(ErrorPage, { errorMsg: this.state.error });
        }
        if (!this.state.loadingData && this.state.stateId === null) {
            return React.createElement(ErrorPage, { errorMsg: `Session verification failed. (State ID: NULL)` });
        }
        if (this.state.loadingData) {
            return React.createElement(LoadingPage, { progressTitle: '', status: this.state.loadingResourceTxt });
        }
        const stateContext = {
            canvasAssignmentGroups: this.state.assignmentGroups,
            canvasDataFailed: this.state.canvasDataFailed,
            canvasDataLoaded: this.state.canvasDataLoaded,
            canvasModules: this.state.modules,
            customExams: this.state.customExams,
            customExamsLoaded: this.state.customExamsLoaded,
            featureFlags: this.state.featureFlags,
            featureFlagsLoaded: this.state.featureFlagsLoaded,
            hasFeatureFlag: (featureFlagKey) => Boolean(this.state.featureFlags[featureFlagKey]),
            isFamilyCanvas: () => PlatformHelper.isFamilyCanvas(this.state.serverState),
            isFamilyDesire2Learn: () => PlatformHelper.isFamilyDesire2Learn(this.state.serverState),
            isIntegrationLTIAdvantage: () => PlatformHelper.isIntegrationLTIAdvantage(this.state.serverState),
            isFamilyMoodle: () => PlatformHelper.isFamilyMoodle(this.state.serverState),
            onCanvasDataLoaded: () => this._canvasDataPromise,
            onCustomExamsLoaded: () => this._customExamsPromise,
            onProductsLoaded: () => this._productDataPromise,
            onLockedVersionsLoaded: () => this._lockedVersionsPromise,
            products: this.state.products,
            productsLoaded: this.state.productsLoaded,
            serverState: this.state.serverState,
            stateId: this.state.stateId,
            lockedVersions: this.state.lockedVersions,
            getMigratedToLockedProducts: this.getMigratedToLockedProducts,
            getMigratedFromLockedProducts: this.getMigratedFromLockedProducts,
            useLatestResource: this.state.useLatestResource,
            setUseLatestResource: (useLatestResource) => this.setState({ useLatestResource }),
            showRetirementNotice: this.state.showRetirementNotice,
            setShowRetirementNotice: (showRetirementNotice) => {
                this.setState({ showRetirementNotice });
            },
        };
        return (React.createElement("div", { className: 'App' },
            React.createElement(StateContext.Provider, { value: stateContext },
                React.createElement(Routing, null))));
    }
}
export function useStateContext() {
    const context = useContext(StateContext);
    if (!context)
        throw new Error('useStateContext must be used within a StateContext context provider.');
    return context;
}
//# sourceMappingURL=App.js.map